module.exports = __webpack_public_path__ + "img/p5.ca637198.png";